import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MyHttpClient } from '../../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SvoService } from 'src/app/svo.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerStatsService {
  constructor(private http: MyHttpClient, private svoService: SvoService) { }
  server = `${environment.server}`;
  getAvgRatingUrl = this.server + '/api/getAvgRating'; // make this configurable

  getAvgRating(id, body) {
    return this.http.post(this.getAvgRatingUrl + '/' + id, body).pipe(catchError(this.handleError));
  }

  async getAverageRatingFromSvoc(id) {
    return await this.svoService.getAverageCustomerRatings(id);
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(error);
  }
}
